import {
  bridgeItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  productMaterialCharacteristicsSchema,
  productPreferencesSchema,
  ProductTypeEnum,
  type BridgeProduct,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps";
import { AdjacentTeethStep, MaterialStep, PreferencesStep } from "./constants";

export type BridgeStepKey =
  | typeof StepKeysEnum.adjacentTeeth
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences;

export const BridgeWorkflowConfiguration: ProductWorkflowConfiguration<
  BridgeProduct,
  BridgeStepKey
> = {
  productType: ProductTypeEnum.bridge,
  itemType: ItemTypeEnum.bridge,
  steps: [new AdjacentTeethStep(), new MaterialStep(), new PreferencesStep()],
  teethSelection: TeethSelectionEnum.ADJACENT,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: bridgeItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    const completed: BridgeStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.adjacentTeeth);
    }

    const isMaterialStepComplete =
      productMaterialCharacteristicsSchema.safeParse(product).success;

    if (product.items?.length && isMaterialStepComplete) {
      completed.push(StepKeysEnum.material);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
